import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading || store[NAME].isLoadingPreview;
export const getData = store => store[NAME].data;
export const getInitialData = store => store[NAME].initialData;
export const getSummaryData = store => store[NAME].summaryData;
export const getIsAcceptRejectEnabled = store => store[NAME].isAcceptRejectEnabled;
export const getIsSocietySignActive = store => store[NAME].isSocietySignActive;